import { render, staticRenderFns } from "./vipcenter.vue?vue&type=template&id=5c3d3f53&scoped=true&"
import script from "./vipcenter.vue?vue&type=script&lang=js&"
export * from "./vipcenter.vue?vue&type=script&lang=js&"
import style0 from "./vipcenter.vue?vue&type=style&index=0&id=5c3d3f53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3d3f53",
  null
  
)

export default component.exports